import Logofill from "../assets/img/logoFill_balck.svg";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import OtpInput from "react-otp-input";
import { useForm } from "react-hook-form";
import {
  userLogin,
  mobileLogin,
  resendOtp,
  verifyOtp,
  fetchProfileData,
  getAuth,
  resetVerifyOtp,
  resetResendOtp,
  initiatePasskeylogin,
} from "../redux/slices/authSlice";
import { getRecaptcha } from "../redux/slices/recaptchaSlice";
import { getUser, getUserToken, setUserToken } from "../libs/user";
import { CompleteRegistration } from "../libs/events";
import { inputFormat, phoneValidation } from "../utils/validation";
import AppSkeleton from "../components/Skeletons/AppSkeleton";
import CustomPopupBox from "./CustomPopupBox";
import logoCross from "../assets/img/logoCross.svg";
import emailLogo from "../assets/img/emailLogo.svg";

const Login = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { loader } = useSelector((state) => state.app);

  const authToken = getUserToken();
  const [mount, setMount] = useState(false);
  const [mobileInput, setMobileInput] = useState(false);
  const [emailReadOnly, setEmailReadOnly] = useState(false);

  const [phone, setPhone] = useState("");
  const [phoneError, setPhoneError] = useState(false);
  const [otpErr, setOtpErr] = useState("");
  const [showPopup, setShowPopup] = useState(false);
  const [verifyOtpSuccess, setverifyOtpSuccess] = useState(false);
  const [sendOTPSuccess, setSendOTPSuccess] = useState(false);
  const [updatedEmail, setUpdatedEmail] = useState("");

  const [counter, setCounter] = useState(0);
  const [screentype, setScreenType] = useState(0);

  const auth = useSelector((state) => state.auth);
  const referee = useSelector((state) => state.referee);
  const message_id = useSelector((state) => state.auth.user?.data?.message_id);
  const loggedInMail = auth?.user?.data?.user?.email_updated;

  const interval0 = useRef();

  const fingerprint = useSelector((state) => state.fingerprint);
  const recaptcha = useSelector((state) => state.recaptcha);

  const [otp, setOtp] = useState("");

  const NUMBER = /^[0-9]*$/;

  const loginType = searchParams.get("type");

  useEffect(() => {
    if (loginType === "mobile") {
      setMobileInput(true);
    }
  }, [loginType]);

  const {
    register,
    handleSubmit,
    watch,
    reset,
    setValue,
    formState: { errors },
  } = useForm();
  const login = (data) => {
    dispatch(
      userLogin({
        email: data.email,
        password: data.password,
        reCaptcha: recaptcha.data,
        deviceId: fingerprint.data,
      })
    )
      .unwrap()
      .then((response) => {
        dispatch(fetchProfileData({ token: response.token }));
        dispatch(getAuth());
        navigate("/accounts", { replace: true });
      })
      .catch((error) => {
        if (error?.error?.code === 4013 || error?.error?.code === 9002) {
          navigate("/resetPassword", { replace: true });
        }
        // dispatch(getRecaptcha({ action: "login" }));
      });
  };

  const handleVerifyOtp = () => {
    if (isValidForm()) {
      const formattedPhone = ("+1" + phone).replace(/[- )(]/g, "");
      dispatch(
        verifyOtp({ otp, phone: formattedPhone, message_id, fingerprint })
      )
        .unwrap()
        .then(async (response) => {
          const storedUserData = await getUser();
          const mailUpdated = storedUserData?.user?.email_updated;
          setverifyOtpSuccess(true);
          setUserToken(response.token);
          if (!mailUpdated) {
            navigate("/signup", { replace: true });
          } else {
            navigate("/accounts", { replace: true });
          }

          return;
        })
        .catch((error) => {
          setOtpErr(error?.error?.message);
          setverifyOtpSuccess(false);
        });
    }
  };
  const startLogin = () => {
    setMobileInput(true);
    if (phone) {
      setPhone("");
    }
  };
  const emailLogin = () => {
    setMobileInput(false);
  };
  const handleChange = (e) => {
    const tempVal = inputFormat(e);
    setPhone(tempVal);
    setPhoneError(false);
  };

  const handleLogin = () => {
    if (validatePhone()) {
      const input = ("+1" + phone).replace(/[- )(]/g, "");
      dispatch(
        mobileLogin({
          mobile_number: input,
          reCaptcha: recaptcha.data,
          deviceId: fingerprint.data,
        })
      )
        .unwrap()
        .then((response) => {
          // setShowPopup(true);
          dispatch(getAuth());
          setScreenType(2);
        })
        .catch((error) => {
          if (error?.error?.code === 4001) {
            setShowPopup(true);
          }
          dispatch(getRecaptcha({ action: "login" }));
        });
    }
  };
  const validatePhone = () => {
    const formattedPhone = phoneValidation(phone);
    if (formattedPhone) {
      setPhone(formattedPhone);
      setPhoneError(false);
      return true;
    } else {
      setPhoneError("Please enter valid number");
      return false;
    }
  };
  const isValidForm = () => {
    if (!otp || otp.length !== 6) {
      return false;
    }
    return true;
  };
  const handleKeyUp = (e) => {
    if (otp.length === 6) {
      e?.target?.blur();
      handleVerifyOtp();
    }
  };

  const handleOtpChange = (value) => {
    if (NUMBER.test(Number(value))) {
      setOtp(value);
    }
  };

  const handleResendOTP = () => {
    const input = ("+1" + phone).replace(/[- )(]/g, "");
    setOtpErr("");
    setOtp("");
    dispatch(
      resendOtp({
        phone: input,
        message_id,
      })
    )
      .unwrap()
      .then((response) => {
        setSendOTPSuccess(true);
        CompleteRegistration();
      })
      .catch((error) => {
        setSendOTPSuccess(false);
        console.log(error);
      });
    setSendOTPSuccess(false);
  };

  const checkPassKeySupport = async () => {
    const PublicKeyCredential = window.PublicKeyCredential;
    if (
      typeof window.PublicKeyCredential !== "undefined" &&
      typeof window.PublicKeyCredential.isConditionalMediationAvailable ===
        "function"
    ) {
      const available =
        await PublicKeyCredential.isConditionalMediationAvailable();
      if (available) {
        console.log("available");
        try {
          // const authOptions = await getAuthenticationOptions();
          // const webAuthnResponse = await navigator.credentials.get({
          //   mediation: "conditional",
          //   publicKey: {
          //     ...authOptions,
          //     // see note about userVerification below
          //     userVerification: "preferred",
          //   },
          // });
          // // Send the response to your server for verification and
          // // authenticate the user if the response is valid.
          // await verifyAutoFillResponse(webAuthnResponse);
          dispatch(
            initiatePasskeylogin({ navigate, deviceId: fingerprint.data })
          );
        } catch (err) {
          console.error("Error with conditional UI:", err);
        }
      }
    }
  };

  useEffect(() => {
    setMobileInput(true);
    if (!phone) {
      setScreenType(1);
    }
    if (fingerprint?.data) {
      checkPassKeySupport();
    }
  }, [fingerprint]);

  useEffect(() => {
    if (sendOTPSuccess) {
      setCounter(60);
    }
  }, [sendOTPSuccess]);

  useEffect(() => {
    if (screentype === 2) setCounter(60);
    return () => {
      dispatch(resetVerifyOtp());
      dispatch(resetResendOtp());
    };
  }, [screentype]);

  useEffect(() => {
    if (screentype === 2) {
      counter > 0 && setTimeout(() => setCounter(counter - 1), 1000);
    }
  }, [screentype, counter]);

  useEffect(() => {
    if (authToken) {
      navigate("/accounts", { replace: true });
    }
  }, [authToken]);

  // useEffect(() => {
  //   dispatch(getRecaptcha({ action: "login" }));
  // }, []);

  useEffect(() => {
    setMount(true);
    if (mount === true) {
      // const userData = JSON.parse(sessionStorage.getItem("userData") || "{}");
      // reset({ email: userData.username });

      interval0.current = setInterval(() => {
        if (watch("email") === "") {
          const userData = JSON.parse(
            sessionStorage.getItem("userData") || "{}"
          );
          if (userData.username) {
            reset({ email: userData.username });
            setEmailReadOnly(true);
          }
        } else {
          clearInterval(interval0.current);
        }
      }, 500);
    }

    return () => {
      clearInterval(interval0.current);
    };
  }, [mount]);

  const handleAction = () => {
    setShowPopup(false);
    navigate("/login", { replace: true });
  };

  const handleContinue = () => {
    navigate("/signup", { replace: true });
  };

  return (
    <>
      {/* <p>login works!</p> */}
      <div className="containtLndPg login-pg-container">
        {/* login content starts*/}
        <div className="center-container">
          <div className="center-container-box container1">
            {screentype === 1 && (
              <div className="logo-login">
                <Link to="">
                  <img src={Logofill} alt="logo" />
                </Link>
              </div>
            )}
            {screentype === 2 && (
              <>
                <h2 className={`verifyHeader`}>Verify your phone</h2>
                <div className={`verifyTextContainer`}>
                  <span className={`codeText`}>
                    We sent a 6 digit code to +1 {phone}.
                  </span>

                  <span className={`codeText1`}>Please enter it below.</span>
                </div>
              </>
            )}
            <div className="login-form login">
              <form
                onSubmit={
                  mobileInput ? handleSubmit(handleLogin) : handleSubmit(login)
                }
              >
                <div className="field-box">
                  <div className="formGroup frmError frm-emial-error">
                    {screentype === 1 && (
                      <>
                        {!mobileInput && (
                          <>
                            {/* {(errors.email?.type === "required" ||
                              errors.password?.type === "required") && (
                              <div className="error-box">
                                <p>
                                  Email and Password fields cannot be blank.
                                </p>
                              </div>
                            )} */}
                            {errors.email?.type === "pattern" && (
                              <div className="error-box show-error-box">
                                <p>Please enter a valid email.</p>
                              </div>
                            )}
                            {auth.validateEmail.error &&
                              !(errors.email || errors.password) && (
                                <div className="error-box">
                                  <p>{auth.validateEmail.error.message}</p>
                                </div>
                              )}
                            {auth.userLogin.error &&
                              !auth.validateEmail.error &&
                              !(errors.email || errors.password) && (
                                <div className="error-box">
                                  <p>{auth.userLogin.error.message}</p>
                                </div>
                              )}
                          </>
                        )}
                      </>
                    )}

                    {screentype === 1 && (
                      <>
                        {mobileInput && (
                          <>
                            {!phone && phoneError && (
                              <div className="error-box">
                                <p>Field cannot be blank.</p>
                              </div>
                            )}
                            {phone && phoneError && (
                              <>
                                <div className="error-box">
                                  <p>{phoneError}</p>
                                </div>
                              </>
                            )}
                            {auth.mobileLoginService.error &&
                              phone &&
                              !phoneError && (
                                <div className="error-box">
                                  <p>{auth.mobileLoginService.error.message}</p>
                                </div>
                              )}
                            {auth.userLogin.error &&
                              !auth.validateEmail.error &&
                              !(errors.email || errors.password) && (
                                <div className="error-box">
                                  <p>{auth.userLogin.error}</p>
                                </div>
                              )}
                          </>
                        )}
                      </>
                    )}
                  </div>
                  {screentype === 1 && (
                    <>
                      {!mobileInput ? (
                        <>
                          <div className="formGroup">
                            <input
                              readOnly={emailReadOnly}
                              onKeyDown={(e) => {
                                setValue("email", e.target.value.trim());
                                setUpdatedEmail(e.target.value);
                              }}
                              type="text"
                              className={`frmControl ${
                                errors.email ? "inputErr" : ""
                              }`}
                              placeholder="name@example.com"
                              {...register("email", {
                                required: true,
                                pattern:
                                  /^\w+([\.+-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/,
                              })}
                            />
                          </div>
                          <div className="formGroup">
                            <input
                              onKeyDown={(e) => {
                                setValue("password", e.target.value.trim());
                              }}
                              type="password"
                              className={`frmControl ${
                                errors.password ? "inputErr" : ""
                              }`}
                              placeholder="Password"
                              {...register("password", {
                                required: true,
                                minLength: 8,
                              })}
                            />
                          </div>
                          {loader ? (
                            <AppSkeleton
                              height={84}
                              width="100%"
                              className="btnLoader"
                            />
                          ) : (
                            <div className="btn-sec mb15">
                              <button
                                type="submit"
                                id="android"
                                className="btnSecondry-new btnBlock"
                              >
                                Log In
                              </button>
                            </div>
                          )}
                          <div className={`forgotPswd`}>
                            <label className={`rememberField`}>
                              <input
                                type="checkbox"
                                className={`checkboxfield`}
                              />
                              Remember me
                            </label>

                            <div
                              className="login-act"
                              style={{ textAlign: "center" }}
                            >
                              <Link to="/resetPassword" className="text-link">
                                Forgot your password?
                              </Link>
                            </div>
                          </div>
                        </>
                      ) : (
                        <>
                          <div className={`mobileInptContainer`}>
                            <span className={`countryCode`}>+1</span>
                            <input
                              className={`mobileInput ${
                                errors.phone ? "inputErr" : ""
                              }`}
                              id="phone"
                              type="tel"
                              value={phone}
                              placeholder=" Phone Number"
                              {...register("phone", {
                                required: true,
                                autoComplete: "username webauthn",
                              })}
                              name="phone"
                              onChange={handleChange}
                              maxLength={14}
                              autoComplete="username webauthn"
                            />
                          </div>

                          {loader ? (
                            <AppSkeleton
                              height={84}
                              width="100%"
                              className="btnLoader"
                            />
                          ) : (
                            <div className="btn-sec mb15">
                              <button
                                className="btnSecondry-new btnBlock"
                                type="submit"
                              >
                                Log In
                              </button>
                            </div>
                          )}
                        </>
                      )}
                    </>
                  )}

                  {screentype === 2 && (
                    <div onKeyUp={handleKeyUp} className={`otpInput`}>
                      <OtpInput
                        shouldAutoFocus={true}
                        numInputs={6}
                        value={otp}
                        onChange={handleOtpChange}
                        inputStyle={`input_style`}
                        className={`formGroupOtp`}
                        renderInput={(props) => (
                          <input {...props} type="number" inputMode="numeric" />
                        )}
                      />

                      <span className="errMsg">{otpErr}</span>
                      {auth.resendOtp?.error?.error?.message &&
                        !errors.otp &&
                        !otpErr && (
                          <span className="errMsg">
                            {auth.resendOtp?.error?.error?.message}
                          </span>
                        )}
                    </div>
                  )}
                </div>

                {screentype === 1 && (
                  <>
                    <div className={`borderContainer`}>
                      <div className={`border`}></div>
                      <div className={`text5`}>
                        <span>OR</span>
                      </div>
                      <div className={`border`}></div>
                    </div>
                    {!mobileInput ? (
                      <div className="loginBtn btn-sec mb15 btnBlock">
                        <button
                          id="android"
                          className="mobileLoginBtn-new btnLogin"
                          onClick={startLogin}
                        >
                          Log In with Phone Number
                        </button>
                      </div>
                    ) : (
                      <div className=" loginBtn btn-sec mb15 btnBlock">
                        <button
                          id="android"
                          className="mobileLoginBtn-new btnLogin"
                          onClick={emailLogin}
                        >
                          Log In with Email
                        </button>
                      </div>
                    )}
                    <div className="sign-up-sec">
                      <p>
                        New to Abound?{" "}
                        <Link to="/signup" className="text-link">
                          Sign Up Now
                        </Link>
                      </p>
                    </div>
                  </>
                )}
                {sendOTPSuccess && screentype === 2 && counter !== 0 && (
                  <div className={`resendContainer`}>
                    <span className={`resendOTPtext`}>New Code Sent!</span>
                  </div>
                )}

                {screentype === 2 && (
                  <>
                    {auth.resendOtp?.error?.error?.code === 5029 ? (
                      ""
                    ) : (
                      <>
                        {counter !== 0 ? (
                          <div className="mobileInputText">{`Resend code in ${counter}s`}</div>
                        ) : (
                          <div className={`sendCode`}>
                            <a onClick={handleResendOTP}>
                              {" "}
                              {"Send Code Again ->"}
                            </a>
                          </div>
                        )}
                      </>
                    )}
                  </>
                )}
              </form>
            </div>
          </div>
        </div>
        {showPopup && (
          <CustomPopupBox
            imgSrc={logoCross}
            imgClass="logoImg"
            heading1="Phone number not found. "
            heading2="Do you have an Abound account?"
            headingClass="accountHeader"
            descrText1="The phone number you're trying to log in with doesn't exist."
            descrText2=" If you have an account, try logging in with your email ID."
            descrClass="descrText"
            btnTxt1="Yes"
            btnTxt2="No, I want to create a new account"
            handleAction={() => handleAction()}
            handleContinue={() => handleContinue()}
          />
        )}
      </div>
    </>
  );
};
export default Login;
